// Keep in sync with backend/version.py APP_VERSION — the admin banner flags a mismatch as a stale deployment.
export const APP_VERSION = "2026.09.19.1";
